import { z } from 'zod'
import { UserSchema } from './common'

export const AuditCommentSchema = z.object({
  id: z.number(),
  user: UserSchema,
  content: z.string(),
  created_at: z.coerce.date(),
  modified_at: z.coerce.date().nullish()
})
